export default __webpack_public_path__ + "static/media/TITULOS_06.5e56c835.png";